import React, { ReactElement, Suspense } from 'react';

import { NuqsAdapter } from 'nuqs/adapters/react-router/v7';
import { BrowserRouter, Route, Routes } from 'react-router-dom';

import { Spinner } from '@/components/spinners/Spinner';
import { ENV } from '@/constants/env';
import { ROUTES } from '@/constants/routes';
import { RequireAuth } from '@/features/auth/components/RequireAuth';
import { PageContainer } from '@/features/pageContainer/components/PageContainer';
import { PageContainerProvider } from '@/features/pageContainer/providers/PageContainerProvider';

// Basename debe empezar por '/' y no acabar por '/', lo intentamos asegurar con un poco de magia regex
const BASE_NAME = ENV.BASE_PATH ? ENV.BASE_PATH.replace(/^\/?(.+)\/$/, '/$1').replace(/\/{1,}/g, '/') : undefined;

const ROUTES_COLLECTION = Object.values(ROUTES).map(({ route, componentPath, component, isPrivate }) => {
    const LazyComponent: React.LazyExoticComponent<() => ReactElement> = React.lazy(() =>
        import(`./pages/${componentPath}/${component}.tsx`).then((module) => ({ default: module[component] })),
    );

    const pageContainer: ReactElement = (
        <PageContainer>
            <Suspense fallback={<Spinner backdrop />}>
                <LazyComponent />
            </Suspense>
        </PageContainer>
    );

    return (
        <Route
            key={route}
            path={route}
            element={isPrivate ? <RequireAuth>{pageContainer}</RequireAuth> : pageContainer}
        />
    );
});

export function AppRouter() {
    return (
        <BrowserRouter basename={BASE_NAME}>
            <NuqsAdapter>
                <PageContainerProvider>
                    <Routes>{ROUTES_COLLECTION}</Routes>
                </PageContainerProvider>
            </NuqsAdapter>
        </BrowserRouter>
    );
}
